// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "eu-west-1",
    "stage": "staging",
    "accountName": "sky",
    "api_url": "https://7t9o0ka7xj.execute-api.eu-west-1.amazonaws.com/staging/graphql",
    "notifications_api_url": "https://7t9o0ka7xj.execute-api.eu-west-1.amazonaws.com/staging/notifications",
    "run_daily_test_url": "https://hfyf1yh0h5.execute-api.eu-west-1.amazonaws.com/staging/run-daily-test",
    "sport_highlights_url": "https://f2ibzazeqvfoxeh5wt6nxx2xne.appsync-api.eu-west-1.amazonaws.com/graphql",
    "appconfig_url": "https://7t9o0ka7xj.execute-api.eu-west-1.amazonaws.com/staging/getConfig",
    "direct_appconfig_url": "https://n0fwc41oje.execute-api.eu-west-1.amazonaws.com/staging",
		"endpoint_url" : "https://7t9o0ka7xj.execute-api.eu-west-1.amazonaws.com/staging",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "eu-west-1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_pgaxOQ67G",
    "aws_user_pools_web_client_id": "4uh7qef8sn1n7gdbkj5dvmv0mh",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-staging.auth.eu-west-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.staging.spex.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.staging.spex.aidisco.sky.com",
        "responseType": "code"
    },
    "bitmovinLicenseKey": "2c2acb4c-6bb3-4087-98d2-0d5ecc0a6258",
    "defaultChannelName": "ExternalSLE",
    "licenseAcquisitionEndpointUrl": "",
    "arcusLicenseAcquisitionEndpointUrl": ""
};

export default awsConfig;

